<script>
import Modal from '@phoenix/mixins/components/common/Modal';
import ModalCloseButton from '@maison/components/common/ModalCloseButton.vue';

export default {
  components: {
    ModalCloseButton,
  },

  mixins: [Modal],

  data() {
    return {
      baseClasses: ['modal dialog box'],
    };
  },

  computed: {
    _headerClasses() {
      return ['dialog__header', ...this.headerClasses];
    },
  },
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div class="modal__overlay" tabindex="-1">
      <div class="modal__container" role="dialog" aria-modal="true" :aria-labelledby="`${id}-title`" :data-cy="dataCy">
        <header :class="_headerClasses">
          <div :id="`${id}-title`" class="dialog__header-title heading-small" aria-level="1">{{ title }}</div>

          <modal-close-button v-if="isClosable" :modal-id="id" />
        </header>

        <slot name="header" />

        <main :id="`${id}-content`" :class="_contentClasses">
          <slot name="content" />
        </main>

        <footer v-if="hasFooterSlot" class="modal__footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </div>
</template>
